import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "cinema-slide__content index hide-scrollbar disable-overscroll-y"
};
import Collection from '@remote/components/cinema/CinemaCollection.vue';
import RecentPlay from '@remote/components/cinema/CinemaRecentPlay.vue';
import CinemaFolderShortcut from '@remote/components/cinema/CinemaFolderShortcut.vue';
import { computed, onBeforeUnmount, onMounted, watch } from 'vue';
import { useDeviceStore } from '@remote/store/device';
import CinemaEmpty from '@remote/components/cinema/CinemaEmpty.vue';
import { stat } from '@remote/utils/stat';
export default /*#__PURE__*/_defineComponent({
  __name: 'CinemaSlideIndex',
  props: {
    isShowing: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const deviceStore = useDeviceStore();
    const indexMovieCollection = computed(() => {
      var _deviceStore$currentN, _deviceStore$currentN2;
      return (_deviceStore$currentN = (_deviceStore$currentN2 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN2 === void 0 ? void 0 : _deviceStore$currentN2.movieList.slice(0, 30)) !== null && _deviceStore$currentN !== void 0 ? _deviceStore$currentN : [];
    });
    const indexTVCollection = computed(() => {
      var _deviceStore$currentN3, _deviceStore$currentN4;
      return (_deviceStore$currentN3 = (_deviceStore$currentN4 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN4 === void 0 ? void 0 : _deviceStore$currentN4.tvList.slice(0, 30)) !== null && _deviceStore$currentN3 !== void 0 ? _deviceStore$currentN3 : [];
    });
    const first10RecentPlay = computed(() => {
      var _deviceStore$currentN5, _deviceStore$currentN6;
      return (_deviceStore$currentN5 = deviceStore === null || deviceStore === void 0 || (_deviceStore$currentN6 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN6 === void 0 ? void 0 : _deviceStore$currentN6.playRecordList) !== null && _deviceStore$currentN5 !== void 0 ? _deviceStore$currentN5 : [];
    });
    const indexShortCut = computed(() => {
      var _deviceStore$currentD;
      return (_deviceStore$currentD = deviceStore.currentDeviceRef) === null || _deviceStore$currentD === void 0 ? void 0 : _deviceStore$currentD.indexShortCut;
    });
    const isShortCutShow = computed(() => {
      var _indexShortCut$value, _indexShortCut$value2;
      return ((_indexShortCut$value = indexShortCut.value) === null || _indexShortCut$value === void 0 ? void 0 : _indexShortCut$value.isCinemaIndexFolderEnabled) && ((_indexShortCut$value2 = indexShortCut.value) === null || _indexShortCut$value2 === void 0 ? void 0 : _indexShortCut$value2.isCinemaIndexFolderShow) && indexShortCut.value.folderList.length > 0;
    });
    const refreshRecentPlay = async () => {
      if (!document.hidden) {
        var _deviceStore$currentN7;
        await (deviceStore === null || deviceStore === void 0 || (_deviceStore$currentN7 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN7 === void 0 ? void 0 : _deviceStore$currentN7.refreshPlayRecord());
      }
    };
    onMounted(() => {
      document.addEventListener('visibilitychange', refreshRecentPlay);
    });
    onBeforeUnmount(() => {
      document.removeEventListener('visibilitychange', refreshRecentPlay);
    });
    const isAllCollectionEmpty = computed(() => {
      return indexMovieCollection.value.length === 0 && indexTVCollection.value.length === 0;
    });
    const hasInitCinema = computed(() => {
      var _deviceStore$currentN8;
      return (_deviceStore$currentN8 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN8 === void 0 ? void 0 : _deviceStore$currentN8.hasInitCinema;
    });
    const hasListInit = computed(() => {
      var _deviceStore$currentN9;
      return !isAllCollectionEmpty.value || ((_deviceStore$currentN9 = deviceStore.currentNFOInstance) === null || _deviceStore$currentN9 === void 0 ? void 0 : _deviceStore$currentN9.hasMovieListInit) && deviceStore.currentNFOInstance.hasTVListInit;
    });
    watch(() => props.isShowing, () => {
      if (props.isShowing) {
        var _deviceStore$currentN10, _deviceStore$currentD2, _deviceStore$currentD3;
        stat({
          action: 'cinema_channel_show',
          data: {
            if_content_blank: isAllCollectionEmpty.value ? 1 : 0,
            page: 'main_page',
            status: (_deviceStore$currentN10 = deviceStore.currentNFOInstance) !== null && _deviceStore$currentN10 !== void 0 && _deviceStore$currentN10.isScraping ? 1 : 0,
            if_have_main_page_file: ((_deviceStore$currentD2 = deviceStore === null || deviceStore === void 0 || (_deviceStore$currentD3 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD3 === void 0 ? void 0 : _deviceStore$currentD3.indexShortCut.folderList.length) !== null && _deviceStore$currentD2 !== void 0 ? _deviceStore$currentD2 : 0 > 0) ? 1 : 0
          }
        });
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!hasInitCinema.value || isAllCollectionEmpty.value && !isShortCutShow.value ? (_openBlock(), _createBlock(CinemaEmpty, {
        key: 0,
        "has-list-init": hasListInit.value
      }, null, 8, ["has-list-init"])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(RecentPlay, {
        title: "最近播放",
        list: first10RecentPlay.value
      }, null, 8, ["list"]), _withDirectives(_createVNode(CinemaFolderShortcut, null, null, 512), [[_vShow, isShortCutShow.value]]), _createVNode(Collection, {
        title: "最近添加的电影",
        nfos: indexMovieCollection.value,
        from: "home_recently_added_movie"
      }, null, 8, ["nfos"]), _createVNode(Collection, {
        title: "最近添加的电视剧",
        nfos: indexTVCollection.value,
        from: "home_recently_added_tele"
      }, null, 8, ["nfos"])], 64))]);
    };
  }
});